import i18next from 'i18next';

import { LOCALE_ES, initI18next } from '@growtherapy/i18n';
import { NS_SPROUT_CORE } from '@growtherapy/sprout-ui';

import { NS_SEEDLINGS_CORE } from '@grow-therapy-team/seedling-components';

import { NS_TELEHEALTH_CORE, telehealthCoreResoucesEn } from '.';
import { logger } from '../datadog/logger';
import { getStoredLanguagePreference } from './languagePreference';

export const CROWDIN_DISTRIBUTION_HASH = 'e-55b8f1847490f0b920ba3b3mgk';

export const initI18n = (): void => {
  initI18next(i18next, {
    lng: getStoredLanguagePreference(),
    ns: [NS_TELEHEALTH_CORE, NS_SPROUT_CORE, NS_SEEDLINGS_CORE],
    defaultNS: [NS_TELEHEALTH_CORE, NS_SPROUT_CORE, NS_SEEDLINGS_CORE],
    resources: telehealthCoreResoucesEn,
    additionalSupportedLngs: [LOCALE_ES],
    otaOptions: {
      distributionHash: CROWDIN_DISTRIBUTION_HASH,
      otaLanguages: [LOCALE_ES],
    },
    missingKeyHandler: (lngs, ns, key) => {
      logger.error(`[i18n] Missing translation key: ${key} ns: ${ns} lng: ${lngs} service: telehealth`);
    },
  });
};
